import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
} from './tableSortHelper';

export interface ProcedureCostTrend {
  totalCost: number;
  year: number;
  month: number;
}

export interface ProcedureSpend {
  totalCost: number;
  totalPlanPaid: number;
  totalMemberPaid: number;
  procedure: string;
  procedureFlag: string;
  servicePlace: string;
}

export interface ProcedureFrequnecy {
  totalCost: number;
  procedure: string;
  procedureFlag: string;
  servicePlace: string;
  claims: number;
  claimants: number;
}
export const getXaxisLabels = (monthNumber: number, year: number) => {
  switch (monthNumber) {
    case 0:
      return 'Dec <br/>' + year;
    case 1:
      return 'Jan <br/>' + year;
    case 2:
      return 'Feb <br/>' + year;
    case 3:
      return 'Mar <br/>' + year;
    case 4:
      return 'Apr <br/>' + year;
    case 5:
      return 'May <br/>' + year;
    case 6:
      return 'Jun <br/>' + year;
    case 7:
      return 'Jul <br/>' + year;
    case 8:
      return 'Aug <br/>' + year;
    case 9:
      return 'Sep <br/>' + year;
    case 10:
      return 'Oct <br/>' + year;
    case 11:
      return 'Nov <br/>' + year;
    case 12:
      return 'Dec <br/>' + year;
    default:
      return '';
  }
};
const cellStyles = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '12px',
  fontWeight: 500,
};

export const spendColumns: Columns[] = [
  {
    name: 'Procedure',
    align: 'left',
    cellStyles: cellStyles,
    width: '400px',
    sortColumnName: 'procedure',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Total Cost',
    align: 'right',
    cellStyles: cellStyles,
    sortColumnName: 'totalCost',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    width: '150px',
  },
  {
    name: 'Plan Paid',
    align: 'right',
    sortColumnName: 'totalPlanPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    cellStyles: cellStyles,
    width: '150px',
  },
  {
    name: 'Member Paid',
    align: 'right',
    sortColumnName: 'totalMemberPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    cellStyles: cellStyles,
    width: '160px',
  },
];
export const breadCrumbList = [
  [
    'text',
    'Utilization Summary',
    {
      color: patientAccessTheme.palette.primary[500],
      fontWeight: 500,
    },
  ],
  [
    'text',
    'Procedure Utilization',
    {
      color: patientAccessTheme.palette.text.highemphasis,
      fontWeight: 600,
    },
  ],
];
export const frequencyCloumns: Columns[] = [
  {
    name: 'Procedure',
    align: 'left',
    cellStyles: cellStyles,
    sortColumnName: 'procedure',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
    width: '500px',
  },
  {
    name: 'Total Cost',
    align: 'right',
    cellStyles: cellStyles,
    sortColumnName: 'totalCost',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    width: '200px',
  },
  {
    name: 'Claimants',
    align: 'right',
    cellStyles: cellStyles,
    sortColumnName: 'claimants',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    width: '200px',
  },
  {
    name: 'Claims',
    align: 'right',
    cellStyles: cellStyles,
    sortColumnName: 'claims',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
    width: '200px',
  },
];

export const TOP_PROCEDURES = {
  TITLE: 'Top',
  SUB_TITLE: 'Showing the top procedures by ',
  DROPDOWN_OPTIONS: ['Procedure Cost', 'Procedure Volume'],
};
export const getTableHeader = (proceduresDropdownValue: string) => {
  if (proceduresDropdownValue === 'Procedure Cost') {
    return spendColumns;
  }
  return frequencyCloumns;
};
